import Link from 'next/link'
import { Fragment } from 'react'

/**
 * Renders a flow message from the API with its inline markup: `**bold**`
 * and `[label](href)` — relative hrefs are site links (e.g. `/standorte`).
 */
export default function FlowText({
  text,
  className,
  'data-testid': testId,
}: {
  text: string
  className?: string
  'data-testid'?: string
}) {
  return (
    <p className={className} data-testid={testId}>
      {renderInline(text)}
    </p>
  )
}

const TOKEN = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g

function renderInline(text: string) {
  const nodes: React.ReactNode[] = []
  let last = 0
  for (const match of text.matchAll(TOKEN)) {
    const [raw, bold, label, href] = match
    const index = match.index ?? 0
    if (index > last) nodes.push(text.slice(last, index))
    if (bold !== undefined) {
      nodes.push(<strong key={index}>{bold}</strong>)
    } else {
      nodes.push(
        <Link
          key={index}
          href={href}
          className="underline text-brand-secondary"
          target={href.startsWith('/') ? undefined : '_blank'}
        >
          {label}
        </Link>,
      )
    }
    last = index + raw.length
  }
  if (last < text.length) nodes.push(text.slice(last))
  return nodes.map((node, i) => <Fragment key={i}>{node}</Fragment>)
}
